<div class="user-form-panel" *ngIf="isVisible">
  <div class="panel-overlay" (click)="close()"></div>
  <div class="panel-container">
    <!-- Header -->
    <div class="panel-header">
      <div class="header-label">New Admin</div>
      <div class="header-actions">
        <button class="close-button" (click)="close()" aria-label="Close panel">
          <img src="./assets/images/close.svg">
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="panel-content">
      <!-- Tabs
      <div class="tab-header">
        <button
          class="tab-button active"
          type="button">
          Add Admin
        </button>
      </div> -->

      <!-- Tab Content -->
      <div class="tab-content-wrapper">
        <div class="tab-pane">
          <app-add-admin
            [accountId]="accountId"
            [canWrite]="canWrite"
            (adminCreated)="onAdminCreated($event)"
            (cancel)="onCancel()">
          </app-add-admin>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="panel-footer">
      <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn-save" [disabled]="!canSubmit()" (click)="submit()">Add</button>
    </div>
  </div>
</div>
